export default "__VITE_ASSET__CHQTxsm2__"